import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Title = styled.h1``;

export const BlogPostGrid = styled.section`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
  }
`;

export const FilterContainer = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex: 0 0 33.3%;
    margin-right: 23px;
  }
`;

export const PostsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const PaginationWrapper = styled.div`
  margin: 5rem 0 0;
`;
